import React, { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { COMMUNITY_INFO_MODE } from 'constants/community';
import { CommunityType } from 'types/communities';
import { CommunityContractBenefit } from 'types/contracts';
import { UnitSource } from 'utils/helpers/units';

import { CareDataType } from './careTypes/types';
import { HistoryItemDataType } from './types';

type CommunityInfoContentType = {
  loaded: boolean;
  mode: number;
  communityInfo: CommunityType | undefined;
  unitSource: UnitSource | undefined;
  mappedCareData: CareDataType[];
  history: HistoryItemDataType | undefined;
  isCompetitor: boolean;
  contractBenefits: CommunityContractBenefit[];
  competitors: any[];
  communityInfoRefetch: () => void;
  setMappedCareData: Dispatch<SetStateAction<CareDataType[]>>;
  setCommunityInfo: (info: CommunityType) => void;
  setHistory: (value: HistoryItemDataType | undefined) => void;
};

export const CommunityInfoContext = createContext<CommunityInfoContentType>({
  loaded: false,
  mode: COMMUNITY_INFO_MODE.SYSTEM,
  communityInfo: undefined,
  unitSource: undefined,
  contractBenefits: [],
  mappedCareData: [],
  competitors: [],
  isCompetitor: false,
  history: undefined,
  communityInfoRefetch: () => {
    // Does Nothing
  },
  setMappedCareData: () => {
    // Does Nothing
  },
  setCommunityInfo: () => {
    // Does Nothing
  },
  setHistory: () => {
    // Do nothing
  },
});

export const useCommunityInfoContext = () => useContext(CommunityInfoContext);
